import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { getDict } from "@/utils/dictionary";
import { getSysDictionaryList } from "@/api/sysDictionary";
export default {
  name: "FieldDialog",
  props: {
    dialogMiddle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dbfdOptions: [],
      visible: false,
      dictOptions: [],
      typeSearchOptions: [{
        label: "=",
        value: "="
      }, {
        label: "<>",
        value: "<>"
      }, {
        label: ">",
        value: ">"
      }, {
        label: "<",
        value: "<"
      }, {
        label: "LIKE",
        value: "LIKE"
      }],
      typeOptions: [{
        label: "字符串",
        value: "string"
      }, {
        label: "整型",
        value: "int"
      }, {
        label: "布尔值",
        value: "bool"
      }, {
        label: "浮点型",
        value: "float64"
      }, {
        label: "时间",
        value: "time.Time"
      }],
      rules: {
        fieldName: [{
          required: true,
          message: "请输入field英文名",
          trigger: "blur"
        }],
        fieldDesc: [{
          required: true,
          message: "请输入field中文名",
          trigger: "blur"
        }],
        fieldJson: [{
          required: true,
          message: "请输入field格式化json",
          trigger: "blur"
        }],
        columnName: [{
          required: true,
          message: "请输入数据库字段",
          trigger: "blur"
        }],
        fieldType: [{
          required: true,
          message: "请选择field数据类型",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    getDbfdOptions: function () {
      var _getDbfdOptions = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.dialogMiddle.dataType = "";
              this.dialogMiddle.dataTypeLong = "";
              this.dialogMiddle.fieldSearchType = "";
              this.dialogMiddle.dictType = "";
              if (!this.dialogMiddle.fieldType) {
                _context.next = 2;
                break;
              }
              _context.next = 1;
              return getDict(this.dialogMiddle.fieldType);
            case 1:
              res = _context.sent;
              this.dbfdOptions = res;
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getDbfdOptions() {
        return _getDbfdOptions.apply(this, arguments);
      }
      return getDbfdOptions;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var dictRes;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return getSysDictionaryList({
              page: 1,
              pageSize: 999999
            });
          case 1:
            dictRes = _context2.sent;
            this.dictOptions = dictRes.data.list;
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};